/* eslint-disable import/no-dynamic-require */
import React, { PropsWithChildren } from 'react'
import { RawIntlProvider, createIntlCache, createIntl } from 'react-intl'

// types
import { ContextProps } from '../types/types'

// utils
import { setIntl } from './intl'
import { resolveAppLocale } from './helper'

type LocalizationData = {
	locale: string
	messages: Record<string, string>
}

const cache = createIntlCache()

const createIntInstance = (data: LocalizationData) => {
	const intlInstance = createIntl(
		{
			locale: data.locale,
			messages: data.messages
		},
		cache
	)

	setIntl(intlInstance)

	return intlInstance
}

const LanguageProvider = ({ children, ...props }: PropsWithChildren<ContextProps>) => {
	const { locale } = props // locale here is 'sk-SK', 'cs-CZ', 'de-AT', etc.
	const appLocale = resolveAppLocale(locale)

	// eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
	const messages = require(`../../public/locales/${appLocale}/messages.json`)

	return <RawIntlProvider value={createIntInstance({ messages, locale: appLocale })}>{React.Children.only(children)}</RawIntlProvider>
}

export default LanguageProvider
